import { registerArchetype } from './index.js';
import { applyDamage, computeDamage, lowestHpEnemy, livingEnemies, enemySide, effectiveAtk, effectiveDef } from '../combat.js';
registerArchetype({
    id: 'execute_low_hp',
    apply: ({ state, source, params, rng }) => {
        const mult = params.multiplier ?? 1.5;
        const bonusMult = params.bonusMultiplier ?? 3.0;
        const threshold = params.threshold ?? 0.3;
        const enemies = livingEnemies(state, source.side);
        if (enemies.length === 0)
            return;
        const target = lowestHpEnemy(state, source.side);
        const sourceRt = (source.side === 'A' ? state.sideA : state.sideB)[source.slot];
        const hpPct = target.runtime.hp / target.runtime.hpMax;
        const effMult = hpPct <= threshold ? bonusMult : mult;
        const dmg = computeDamage(effectiveAtk(sourceRt) * effMult, effectiveDef(target.runtime));
        applyDamage(state, source, { side: enemySide(source.side), slot: target.slot }, dmg, false, rng);
    }
});
